// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class RowPropertyClass {
    constructor() {
        this.Id = '';
        this.Group = '';
        this.SortIndex = 0;
        this.LocalizationKey = '';
        this.Hidden = false;
        this.visible = true;
        this.tooltipKey = '';
        this.arrayList = [];
    }
    Properties() {
        return this.arrayList;
    }
    callBack(v) {
        this.arrayList = v;
    }
    Apply(sourceItem) {
        this.visible = sourceItem.visible;
        this.arrayList = sourceItem.Properties;
    }
    ToString() {
        return this.Group + '.' + this.LocalizationKey;
    }
}
